import { axios } from 'lib/axios';
import { useQnaMutation } from './useQnaMutation';

const declineQuestion = (resource, id, { questionId, ...values }) =>
  axios.put(`/api/${resource}/${id}/qna/questions/${questionId}/decline`, values);

export const useDeclineQuestion = (resource, id, onSuccess) =>
  useQnaMutation(resource, id, (values) => declineQuestion(resource, id, values), {
    successMessage: 'Question declined',
    onSuccess,
  });
